import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { SideBlock } from "./SideBlock";
import { selectIsAuth } from "../redux/slices/auth";

import ListItem from "@mui/material/ListItem";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Skeleton from "@mui/material/Skeleton";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export const CommentsBlock = ({
  items,
  children,
  isLoading = true,
  onDelete,
  onEdit,
  isFullPost = false,
}) => {
  const isAuth = useSelector(selectIsAuth);
  const { data: userData } = useSelector((state) => state.auth);
  return (
    <SideBlock title="Коментарі">
      <List>
        {(isLoading ? [...Array(5)] : items).map((obj, index) => (
          <React.Fragment key={index}>
            <ListItem alignItems="flex-start">
              {isLoading ? (
                <Grid
                  container
                  spacing={1}
                  style={{ width: "100%" }}
                  alignItems="center"
                >
                  <Grid item>
                    <Skeleton variant="circular" width={40} height={40} />
                  </Grid>
                  <Grid item xs>
                    <Skeleton variant="text" height={25} width={120} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton variant="text" height={18} width={230} />
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  spacing={1}
                  style={{ width: "100%" }}
                  alignItems="center"
                >
                  <Grid item>
                    <Avatar alt={obj.user.fullName} src={obj.user.avatarUrl} />
                  </Grid>
                  <Grid item xs>
                    <Typography variant="subtitle1" component="div">
                      {obj.user.fullName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {!isFullPost ? (
                      <Link
                        to={`/posts/${obj.postId}`}
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{
                            overflowWrap: "break-word", // Перенос длинных слов
                            wordBreak: "break-word", // Аварийный перенос для очень длинных слов
                            whiteSpace: "pre-line", // Сохраняет переносы строк из текста
                          }}
                        >
                          {obj.text}
                          <span
                            style={{
                              fontSize: 10,
                              marginTop: 10,
                              display: "block",
                            }}
                          >
                            {obj.createdAt}
                          </span>
                        </Typography>
                      </Link>
                    ) : (
                      <div
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{
                            overflowWrap: "break-word", // Перенос длинных слов
                            wordBreak: "break-word", // Аварийный перенос для очень длинных слов
                            whiteSpace: "pre-line", // Сохраняет переносы строк из текста
                          }}
                        >
                          {obj.text}
                          <span
                            style={{
                              fontSize: 10,
                              marginTop: 10,
                              display: "block",
                            }}
                          >
                            {obj.createdAt}
                          </span>
                        </Typography>
                      </div>
                    )}

                    {isAuth &&
                      (userData?._id === obj.user._id || userData?.isAdmin) && (
                        <div style={{ marginTop: 8 }}>
                          <Button
                            size="small"
                            onClick={() => onEdit(obj._id, obj.text)}
                            style={{ marginRight: 8 }}
                          >
                            Змінити
                          </Button>
                          <Button
                            size="small"
                            onClick={() => {
                              if (window.confirm("Удалить комментарий?")) {
                                onDelete(obj._id);
                              }
                            }}
                            color="error"
                          >
                            Видалити
                          </Button>
                        </div>
                      )}
                  </Grid>
                </Grid>
              )}
            </ListItem>
            <Divider variant="inset" component="li" />
          </React.Fragment>
        ))}
      </List>
      {isAuth ? (
        children
      ) : (
        <div style={{ padding: 15, textAlign: "center" }}>
          <Link to="/login">Увійдіть</Link>, щоб залишити коментар
        </div>
      )}
    </SideBlock>
  );
};
